import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70bbf0ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-12" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Data Subscription"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, " Data Subscription ")
  ])
], -1))
const _hoisted_6 = { class: "card-body p-4" }
const _hoisted_7 = { class: "row gx-4 gy-2" }
const _hoisted_8 = { class: "col-lg-3" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_11 = { class: "col-lg-3" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_14 = { class: "col-lg-3" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn btn-danger" }, "Reset")
], -1))
const _hoisted_18 = { class: "table-responsive mt-4" }
const _hoisted_19 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "No"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-1250px; text-left" }, "Customer"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Plan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Next Billing"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Aksi")
  ])
], -1))
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = { class: "text-left" }
const _hoisted_24 = { class: "text-center" }
const _hoisted_25 = {
  class: /*#__PURE__*/_normalizeClass(['badge', 'rounded-pill', 'bg-success'])
}
const _hoisted_26 = { class: "text-center" }
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = { class: "text-center" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-square text-white" }, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Edit", -1))
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { key: 1 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, " Tidak Ada Data ")
], -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "row mt-5 mb-5" }
const _hoisted_37 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_38 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_39 = ["label", "value"]
const _hoisted_40 = { class: "p-3" }
const _hoisted_41 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_42 = {
  key: 0,
  class: "col-lg-4"
}
const _hoisted_43 = { class: "card" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Preview Plan")
  ])
], -1))
const _hoisted_45 = {
  key: 0,
  class: "card-body"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-center" }, "Data tidak ditemukan", -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = {
  key: 1,
  class: "card-body"
}
const _hoisted_49 = { class: "row gy-5" }
const _hoisted_50 = { class: "border border-2 p-4 rounded-2" }
const _hoisted_51 = { class: "row justify-content-between" }
const _hoisted_52 = { class: "col-lg-6" }
const _hoisted_53 = { class: "col-lg-6 text-end" }
const _hoisted_54 = { class: "mt-4" }
const _hoisted_55 = { class: "list-unstyled" }
const _hoisted_56 = { class: "text-primary me-2" }
const _hoisted_57 = { class: "menu-text" }

import { ref, onMounted, computed } from "vue";
import Loading from "vue-loading-overlay";
import InfoBox from "@/components/cards/InfoBox.vue";
import ApiService from "@/core/services/ApiService";
import { PRICE_TYPE } from "../enum";
import { MasterPricing } from "../model/MasterPricing";
import Pagination from "@/components/widgets/custom/Pagination.vue";
import moment from "moment";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  props: {
  widgetClasses: String,
},
  setup(__props) {



const isLoading = ref(false);
const fullPage = ref(true);
const isColor = "#007BFF";
const isBackgroundColor = "#A3A3A3";
const isOpacity = 0.5;

const name = ref("");
const plans = ref<MasterPricing[]>([]);
const priceTypeEnum = ref(PRICE_TYPE);

const route = useRoute();


const paging = ref({
  page: 1,
  totalPages: 0,
  size: 10,
  totalElements: 0,
  perPageOptions: [10, 25, 50, 100],
});

const infoData = ref([
  {
    title: "Total Customer",
    text: "137",
    color: "info",
  },
  {
    title: "Total Aktif",
    text: "30",
    color: "success",
  },
  {
    title: "Total Pending",
    text: "21",
    color: "warning",
  },
  {
    title: "Total Tidak Aktif",
    text: "20",
    color: "danger",
  },
]);

const tableData = ref([]);
const formatPrice = (value) => {
  let val = (value / 1).toFixed(2).replace(".", ",");
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};
const getPlans = (size = 20, page = 1) => {
  isLoading.value = true;
  ApiService.getWithoutSlug(
    "crmv2/main_feature/pricing-plans/all?" +
      "&" +
      "page=" +
      page +
      "&size=" +
      size
  )
    .then(({ data }) => {
      plans.value = data.content;
      isLoading.value = false;
    })
    .catch((error) => {
      console.log(error);
      isLoading.value = false;
    });
};
const getData = (size = 10, page = 1) => {
  isLoading.value = true;
  ApiService.getWithoutSlug(
    "/crmv2/main_feature/subscriptions/all?" +
      "&" +
      "page=" +
      page +
      "&size=" +
      size +
      "&customer_id=" +
      route.params._id
  )
    .then(({ data }) => {
      console.log(data);
      
      tableData.value = data.content;
      paging.value.page = data.page;
      paging.value.size = data.size;
      paging.value.totalElements = data.totalElements;
      paging.value.totalPages = data.totalPages;

      isLoading.value = false;
    })
    .catch((error) => {
      console.log(error);
      isLoading.value = false;
    });
};

const formatDate = (date) => {
  // return moment(date, "D-MM-YYYY HH:mm").format("D-MM-YYYY HH:mm");
  return moment(date).locale("id").format("Do   MMMM YYYY HH:mm");
};

const changePage = (item) => {
  const page = item - 1;
  getData(paging.value.size, page);
};

const nextPage = () => {
  const page = parseInt(paging.value.page.toString()) + 1;
  getData(paging.value.size, page);
};

const prevPage = () => {
  console.log(paging.value.page);
  const page = parseInt(paging.value.page.toString()) - 1;
  getData(paging.value.size, page);
};

const changePageSize = () => {
  const page = paging.value.page;
  getData(paging.value.size, page);
};

const to = computed(() => {
  let highBound = from.value + parseInt(paging.value.size.toString());
  console.log("ini from: ", from.value);
  if (paging.value.totalElements < highBound) {
    highBound = paging.value.totalElements;
  }
  return highBound;
});
const from = computed(() => {
  return paging.value.size * paging.value.page;
});
const pillStyle = computed((val) => {
  return val ? "bg-success" : "bg-danger";
});
onMounted(() => {
  getPlans();
  getData(paging.value.size, paging.value.page);
});

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Loading), {
        active: isLoading.value,
        "is-full-page": fullPage.value,
        color: isColor,
        "background-color": isBackgroundColor,
        opacity: isOpacity
      }, null, 8, ["active", "is-full-page"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass([__props.widgetClasses, "card"])
          }, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control w-full ps-15",
                      placeholder: "Cari Nama Fitur",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                      onKeyup: _cache[1] || (_cache[1] = () => {})
                    }, null, 544), [
                      [_vModelText, name.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control w-full ps-15",
                      placeholder: "Cari Nama Plan",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((name).value = $event)),
                      onKeyup: _cache[3] || (_cache[3] = () => {})
                    }, null, 544), [
                      [_vModelText, name.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control w-full ps-15",
                      placeholder: "Cari Nama Sekolah",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((name).value = $event)),
                      onKeyup: _cache[5] || (_cache[5] = () => {})
                    }, null, 544), [
                      [_vModelText, name.value]
                    ])
                  ])
                ]),
                _hoisted_17
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("table", _hoisted_19, [
                  _hoisted_20,
                  (tableData.value.length)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_21, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableData.value, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", _hoisted_22, _toDisplayString(index + 1), 1),
                            _createElementVNode("td", _hoisted_23, _toDisplayString(item.customer_name), 1),
                            _createElementVNode("td", _hoisted_24, [
                              _createElementVNode("span", _hoisted_25, _toDisplayString(item.pricing_plan_name), 1)
                            ]),
                            _createElementVNode("td", _hoisted_26, [
                              _createElementVNode("span", {
                                class: _normalizeClass([
                            'badge',
                            'rounded-pill',
                            item.is_active ? 'bg-success' : 'bg-danger',
                          ])
                              }, _toDisplayString(item.is_active ? "Aktif" : "Tidak Aktif"), 3)
                            ]),
                            _createElementVNode("td", _hoisted_27, _toDisplayString(formatDate(item.end_date)), 1),
                            _createElementVNode("td", _hoisted_28, [
                              _createElementVNode("a", {
                                class: "symbol symbol-30px me-2 p-2 px-3 text-white bg-warning fw-bold",
                                "data-bs-toggle": "tooltip",
                                title: "Edit",
                                style: {"cursor":"pointer"},
                                onClick: ($event: any) => (
                            _ctx.$router.push(
                              '/superadmin/master-feature/subscription/edit/' +
                                item._id
                            )
                          )
                              }, _hoisted_32, 8, _hoisted_29)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("tbody", _hoisted_33, _hoisted_35))
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("select", {
                        name: "kt_customers_table_length",
                        class: "form-select form-select-sm form-select-solid",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((paging.value.size) = $event)),
                        placeholder: "Per page",
                        onChange: _cache[7] || (_cache[7] = ($event: any) => (changePageSize()))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paging.value.perPageOptions, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: item,
                            label: item,
                            value: item
                          }, null, 8, _hoisted_39))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, paging.value.size]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, " Showing " + _toDisplayString(_unref(from)) + " to " + _toDisplayString(_unref(to)) + " of " + _toDisplayString(paging.value.totalElements) + " entries ", 1)
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(Pagination, {
                    paging: paging.value,
                    "max-visible-pages": 5,
                    onNext: nextPage,
                    onPrev: prevPage,
                    onChange: changePage
                  }, null, 8, ["paging"])
                ])
              ])
            ])
          ], 2)
        ]),
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                (!plans.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, _hoisted_47))
                  : (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plans.value, (plan, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "col-12"
                          }, [
                            _createElementVNode("div", _hoisted_50, [
                              _createElementVNode("div", _hoisted_51, [
                                _createElementVNode("div", _hoisted_52, [
                                  _createElementVNode("h3", null, _toDisplayString(plan.price_title), 1)
                                ]),
                                _createElementVNode("div", _hoisted_53, [
                                  _createElementVNode("p", {
                                    class: _normalizeClass([
                            'badge',
                            'rounded-pill',
                            plan.price_type === 'free'
                              ? 'bg-success'
                              : 'bg-primary',
                          ])
                                  }, _toDisplayString(plan.price_type.toUpperCase()), 3)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("ul", _hoisted_55, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plan.features, (item) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: item.name,
                                      class: "d-flex align-items-center mb-2"
                                    }, [
                                      _createElementVNode("span", _hoisted_56, [
                                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen037.svg" })
                                      ]),
                                      _createElementVNode("span", _hoisted_57, _toDisplayString(item.name), 1)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})